import { StandardProps } from "@/types/types";
import styles from "./CorrectedSearchTerm.module.scss";
import { useRouteParams } from "@/hooks/useRouteParams";

export function CorrectedSearchTerm({
  productListingData,
}: Pick<StandardProps, "productListingData">) {
  const { query } = useRouteParams();
  const { correction, results: totalNumberOfResults } = productListingData;

  if (!correction) {
    return null;
  }

  const { type: correctionType, correctedSearchTerm } = correction;

  if (
    (correctionType !== "NotStockedSubstitute" &&
      correctionType !== "SpellCorrect" &&
      correctionType !== "Substitute") ||
    (correctionType !== "NotStockedSubstitute" && !correctedSearchTerm)
  ) {
    return null;
  }

  const originalSearchTerm = query["search-term"] || "";

  let copy;
  if (correctionType === "NotStockedSubstitute" && totalNumberOfResults > 0) {
    copy = `Sorry, we don't stock ${originalSearchTerm}. Here are ${totalNumberOfResults} ${correctedSearchTerm ? `results for ${correctedSearchTerm}.` : `similar products.`}`;
  } else {
    copy = `Showing ${totalNumberOfResults} result${
      totalNumberOfResults !== 1 ? "s" : ""
    } for '${correctedSearchTerm}'`;
  }

  return (
    <div
      data-component="CorrectedSearchTerm"
      data-testid="corrected-search-term"
      className={styles.correctedSearchTerm}
    >
      <p
        data-testid="corrected-search-term-copy"
        className={styles.correctedSearchTerm__copy}
      >
        {copy}
      </p>
    </div>
  );
}
